<template src="./index.html"></template>

<script>
import { URL, apiCall } from "@/utils/api";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
export default {
  name: "CitizenRequestModal",
  props: {
    selected: Object,
    visible: Boolean,
  },
  components: {
    "conditional-media": ConditionalMedia,
  },
  data() {
    return {
      modalVisible: false,
      citRequest: null,
    };
  },
  methods: {
    getCitRequestDetails() {
      if (!this.selected) return;
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "operator/crequests/" +
          this.selected.id,
      })
        .then((response) => {
          if (!response.data.error) {
            this.citRequest = response.data.data;
          } else this.$message.error(response.data.error.message);
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
    clearData() {
      this.citRequest = null;
    },
  },
  watch: {
    visible: function (newValue, oldValue) {
      this.modalVisible = this.visible;
      if (!oldValue && newValue && this.selected) {
        this.getCitRequestDetails();
      }
    },
    modalVisible: function () {
      if (!this.modalVisible) {
        this.clearData();
        this.$emit("afterClose");
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
